var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconExceptionManagementKanban(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "press",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon-exceptionManagementKanban"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-exceptionManagementKanban",
    clipPath: "url(#clip-icon-exceptionManagementKanban)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M511.589,791.945q-161.931.013-323.916,0a59.634,59.634,0,0,1-61.358-33.8,53.071,53.071,0,0,1,8.27-58.057,734.3,734.3,0,0,0,60.569-84.354A304.365,304.365,0,0,0,232.71,460.3a346.717,346.717,0,0,1,21.473-140.42,269.653,269.653,0,0,1,167.46-156.347c35.079-12.167,35.373-11.268,36.235-48.072A52.584,52.584,0,0,1,511.46,64.051a54.009,54.009,0,0,1,55.252,50.208c.751,12.772-2.439,28.579,3.759,37.556,5.85,8.041,22.537,7.921,33.8,12.359A272.388,272.388,0,0,1,783.738,370.28a373.223,373.223,0,0,1,6.766,78.87,335,335,0,0,0,84.39,232.622c4.126,4.621,7.243,10.141,11.259,14.725A53.893,53.893,0,0,1,897.8,758.2a56.949,56.949,0,0,1-55.05,33.8c-25.911.862-51.895.266-77.862.266Zm43.607-406.2h0c0-26.287.33-52.913,0-79.356a42.177,42.177,0,0,0-36.859-46.89c-1.339-.155-2.7-.256-4.034-.284a42.49,42.49,0,0,0-46.083,38.537,43.227,43.227,0,0,0-.037,7.06c-.971,53.894-.605,107.862,0,161.793a43.916,43.916,0,0,0,18.448,37.555,42.625,42.625,0,0,0,68.308-34.585c1.265-27.763.257-55.819.257-83.793ZM511.9,680.259a53.8,53.8,0,0,0,57.672-49.649,51.437,51.437,0,0,0,.129-5.822,53.875,53.875,0,0,0-56.334-57.012A53.313,53.313,0,0,0,455,624.11,53.131,53.131,0,0,0,511.9,680.3Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M622.715,849.938a105.149,105.149,0,0,1-50.814,91.11,103.264,103.264,0,0,1-118.828.229,101.707,101.707,0,0,1-50.557-91.33Z",
    fill: "currentColor",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExceptionManagementKanban);
export default __webpack_public_path__ + "static/media/icon-exceptionManagementKanban.f4fb02fb928a32b41a61469b375907ab.svg";
export { ForwardRef as ReactComponent };